
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor02On as ObiBipolar_transistor02OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-02-on.js';
 
 
 

 
 export const ObiBipolar_transistor02On = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-02-on',
   elementClass: ObiBipolar_transistor02OnElement,
   events: {
     
   }
  });
 
 